import axios from "axios";
import { api } from "./api_route";

export const createClaimantAdministratorAPI = async (
  claimantAdministratorData,
) => {
  try {
    const config = {};
    if (
      typeof FormData !== "undefined" &&
      claimantAdministratorData instanceof FormData
    ) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.post(
      `${api}/claimantAdministrator/create`,
      claimantAdministratorData,
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const getClaimantAdministratorByCaseIDAPI = async (caseID) => {
  try {
    const response = await axios.get(
      `${api}/claimantAdministrator/case/${caseID}`,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const updateClaimantAdministratorAPI = async (
  claimantAdministratorID,
  claimantAdministratorData,
) => {
  try {
    const config = {};
    if (
      typeof FormData !== "undefined" &&
      claimantAdministratorData instanceof FormData
    ) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.put(
      `${api}/claimantAdministrator/update/${claimantAdministratorID}`,
      claimantAdministratorData,
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const deleteClaimantAdministratorAPI = async (
  claimantAdministratorID,
) => {
  try {
    const response = await axios.delete(
      `${api}/claimantAdministrator/delete/${claimantAdministratorID}`,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const deleteClaimantAdministratorDocumentAPI = async (documentID) => {
  try {
    const response = await axios.delete(
      `${api}/claimantAdministrator/document/delete/${documentID}`,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const claimantAdministratorDocumentDownload = async (values) => {
  try {
    const response = await axios.get(
      `${api}/documents/claimantAdministratorDocuments/${values.original.documentNewName}`,
      {
        responseType: "blob",
      },
    );

    return response.data;
  } catch (error) {
    return [];
  }
};
// Document Categories Constants
export const CLAIMANTADMINISTRATOR_DOCUMENT_CATEGORIES = {
  AUTHORIZATIONLETTER: 1244,
};

export const DOCUMENT_CATEGORY_LABELS = {
  1244: "AuthorizationLetter",
};
